module.exports = __webpack_public_path__ + "img/step_2.579dd84f.svg";